module.exports = __webpack_public_path__ + "img/map.6abf8a49.png";